import { Component } from '@angular/core'

@Component({
  selector: 'efp-page-heading',
  templateUrl: 'page-heading.component.html',
  styleUrls: ['page-heading.component.scss'],
})
export class PageHeadingComponent {}
